// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"sectionTitle--3iCgc"};